var sb = require('@sb/util')
const flow = require('@subiz/flow')
const lo = require('lodash')
import store from '@sb/store'
const NOTI_OVERDUE_TASK_HIDDEN_TIME = 900000 // 15 minutes

export default {
	name: 'instant_noti',
	data() {
		return {
			show: false,
			popupNotis: [],
			showOverdueTask: false,
		}
	},

	async mounted() {
		store.onInstantNoti(this, (newnoti) => this.doNew(newnoti))
		this.computeShouldShowTaskNoti()
	},

	methods: {
		async computeShouldShowTaskNoti() {
			let tasks = await store.listRemindedTasks()
			await store.fetchTasks(lo.map(tasks, (task) => task.id))

			let remindedTask = lo.find(tasks, this.isTaskShouldReminded)
			if (remindedTask) {
				this.$root.$emit('push_noti_message', {
					id: 'task_reminded',
					type: 'task_reminded',
					data: remindedTask,
					priority: 'high',
				})
			}

			let overdueTasks = await store.listOverdueTasks()
			overdueTasks = lo.map(overdueTasks, (task) => store.matchTask(task.id) || {})
			overdueTasks = lo.orderBy(overdueTasks, ['due_at'], ['asc'])
			if (lo.size(overdueTasks)) {
				let shouldShow =
					Date.now() - lo.get(store.me(), 'dashboard_setting.last_close_task_notification', 0) >
					NOTI_OVERDUE_TASK_HIDDEN_TIME
				if (shouldShow)
					this.$root.$emit('push_noti_message', {
						id: 'overdue_tasks', // id so we dont want to split overdue_tasks noti
						type: 'overdue_tasks',
						data: overdueTasks,
						priority: 'high',
					})
			}
		},

		isTaskShouldReminded(task) {
			let dueAt = task.due_at || 0
			let reminder = task.reminder || 0
			let member = lo.find(task.members, (mem) => mem.reminder_closed && mem.agent_id === store.me().id)
			let isClosed = member && member.reminder_closed > dueAt - reminder

			return dueAt && reminder && dueAt > Date.now() && reminder + Date.now() > dueAt && !isClosed
		},

		async doNew(newnoti) {
			if (!newnoti) return this.$forceUpdate()
			if (!newnoti.data) return null
			let data = JSON.parse(newnoti.data) || {}
			let orderid
			if (newnoti.type == 'order_assigned' || newnoti.type === 'order_commented') {
				// dont show instant noti if agent is already viewing the order
				let viewing = store.getViewingOrder()
				if (viewing == data.order_id) return

				orderid = data.order_id
			}
			let uid
			if (newnoti.type == 'task_reminded' || newnoti.type === 'task_expired') {
				this.computeShouldShowTaskNoti()
				return
			}
			if (newnoti.type === 'lead_created' || newnoti.type === 'user_created' || newnoti.type === 'user_returned')
				uid = lo.get(data, 'user.id')
			if (newnoti.type === 'campaign_user_converted' || newnoti.type === 'user_opened_email') {
				uid = lo.get(data, 'user_id')
			}

			let user = null
			// try to fetch user to reduce ui update
			if (uid) {
				user = store.matchUser(uid)
				let start = sb.now()
				while (!user && sb.now() - start < 2000) {
					user = store.matchUser(uid)
					await flow.sleep(200)
				}
			}

			if (orderid) {
				let order = store.matchOrder(orderid)
				let start = sb.now()
				while (!order && sb.now() - start < 10000) {
					order = store.matchOrder(orderid)
					await flow.sleep(200)
				}
				if (!order) return
			}

			if (!newnoti.id) newnoti.id = newnoti.checkpoint + '-' + newnoti.topic
			if (this.popupNotis.find((noti) => noti.id === newnoti.id)) return
			this.$root.$emit('push_noti_message', {type: 'instant_noti', data: newnoti, duration: 6_000})
		},
	},

	render() {
		return null
	},
}
